<template>
    <div class="home">
        <carousel/>
        <div class="top-search">
            <div class="FL">
                <img src="../../static/images/u19.png" alt="" class="info-img">
            </div>
            <div class="FL carousel-search">
                <a-carousel dot-position="right" :dots="false" :autoplay="true">
                    <p @click="getInfos(item.id)" v-for="(item,i) in news" :key="i"
                       style="line-height: 45px;font-size: 16px" class="cursor-pointer">{{ item.title }}</p>
                </a-carousel>
            </div>
            <div class="FR">
                <div class="search-input">
                    <!--                    <a-input-search-->
                    <!--                        placeholder="请输入内容"-->
                    <!--                        enter-button="搜索"-->
                    <!--                        size="default"-->
                    <!--                        @search="getList()"-->
                    <!--                    />-->
                </div>
            </div>
            <div class="FR title-search">
                <!--                <span class="font-weight">热门关键词：</span>流量计 粉碎机-->
            </div>
            <div class="FR search-box"></div>
            <div class="ClearFloat"></div>
        </div>
        <div class="breadcrumb-div">
            <div class="FL">
                <img src="../../static/images/u177.png" alt="" class="breadcrumb-img">
            </div>
            <div class="FL breadcrumb-title">
                {{ $t('lang.position') }}：
            </div>
            <div class="FL">
                <a-breadcrumb class="breadcrumb-main">
                    <a-breadcrumb-item> {{ $t('lang.index1') }}</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
        </div>
        <div class="main-div" style="height: 1330px">
            <div>
                <div class="FR">
                    <a-button type="primary" shape="round" ghost @click="getList()">
                        {{ $t('lang.more') }}
                    </a-button>
                </div>
                <div class="title-max margin-auto">
                    <div class="title-box"></div>
                    <div class="title-box1 text-align">
                        {{ $t('lang.Product') }}
                    </div>
                    <div class="MT30 text-align">{{ $t('lang.Professional') }}</div>
                </div>
            </div>
            <div>
                <div class="FL" >
                    <navComponent/>
                </div>
                <div class="FR" style="width: 1120px;">
                    <a-row type="flex" justify="space-around">
                        <a-col :span="8" v-for="(item,i) in productData.slice(0,6)" :key="i" class="text-align">
                            <div class="margin-auto cursor-pointer" @click="getInfo(item.id)"
                                 style="width: 320px;height: 320px">
                                <img :src="item.image[0].url" style="width: 320px;height: 320px" :alt="item.name">
                            </div>
                            <div style="margin: -20px auto 20px;width: 240px;">
                                <p class="img-title" style="position: sticky" @click="getInfo(item.id)">
                                    <span>{{ item.name }}</span>
                                </p>
                            </div>
                        </a-col>
                    </a-row>
                    <a-row  type=" video-div" justify="space-around">                        
                        <video-player class="video-player vjs-custom-skin videoCustom" 
                                    ref="videoPlayer" 
                                    :playsinline="true" 
                                    :options="playerOptions">
                        </video-player>
                       
                    </a-row>

                </div>

                <div class="ClearFloat"></div>
            </div>
        </div>

        <div class="title-max margin-auto">
            <div class="title-box"></div>
            <div class="title-box1 text-align">
                {{ $t('lang.scope') }}
            </div>
            <div class="MT30 text-align">{{ $t('lang.Professional') }}</div>
        </div>
        <div class="range MT30">
            <a-row type="flex" justify="center" class="text-align MT30 font-weight"
                   style="color: white;font-size: 24px">
                <a-col :span="4">
                    <img src="../../static/images/u82.png" alt="">
                    <p>{{ $t('lang.development') }}</p>
                </a-col>
                <a-col :span="4">
                    <img src="../../static/images/u85.png" alt="">
                    <p>{{ $t('lang.manufacturing') }}</p>
                </a-col>
                <a-col :span="4">
                    <img src="../../static/images/u83.png" alt="">
                    <p>{{ $t('lang.market') }}</p>
                </a-col>
                <a-col :span="4">
                    <img src="../../static/images/u84.png" alt="">
                    <p>{{ $t('lang.Support') }}</p>
                </a-col>
            </a-row>
        </div>
        <div class="main-div MT30">
            <div>
                <div class="FR">
                    <a-button type="primary" shape="round" ghost @click="getInfoC">
                        {{ $t('lang.more') }}
                    </a-button>
                </div>
                <div class="title-max margin-auto">
                    <div class="title-box"></div>
                    <div class="title-box1 text-align">
                        {{ $t('lang.Company') }}
                    </div>
                    <div class="MT30 text-align">{{ $t('lang.Professional') }}</div>
                </div>
            </div>
            <a-row class="MT30">               
                <a-col :span="10">
                    <div class="FL imgBox imgBox1"></div>
                    <div class="FL imgBox imgBox2"></div>
                    <div class="FL imgBox imgBox3"><img src="../../static/images/u66.png" class="imgBox" alt=""></div>
                </a-col>
                <a-col :span="9">
                    <div class="text">
                        <p><span style="margin-left: 40px"></span>
                            {{ $t('lang.Introduction1') }}
                        </p>    
                        <p><span style="margin-left: 40px"></span>
                            {{ $t('lang.Introduction2') }}
                        </p>
                        <p><span style="margin-left: 40px"></span>
                            {{ $t('lang.Introduction6') }}
                        </p>
                        <p class="p1"><span style="margin-left: 40px"></span>
                            {{ $t('lang.Introduction3') }}
                        </p>
                    </div>
                </a-col>
                <a-col :span="5">
                    <a-row class="MT30">
                        <a-col :span="1">
                        </a-col>
                        <a-col :span="14">
                            <img src="../../static/images/u91.png" class="w180" alt="">
                        </a-col>
                        <a-col :span="1">
                        </a-col>
                        <a-col :span="8">
                            <span class="text-left font-weight">{{ $t('lang.innovation') }}</span>
                        </a-col>
                    </a-row>
                    <a-row class="MT30">
                        <a-col :span="1">
                        </a-col>
                        <a-col :span="14">
                            <img src="../../static/images/u90.png" class="w180" alt="">
                        </a-col>
                        <a-col :span="1">
                        </a-col>
                        <a-col :span="8">
                            <span class="text-left font-weight">{{ $t('lang.Cooperation') }}</span>
                        </a-col>
                    </a-row>
                    <a-row class="MT30">
                        <a-col :span="1">
                        </a-col>
                        <a-col :span="14">
                            <img src="../../static/images/u92.png" class="w180" alt="">
                        </a-col>
                        <a-col :span="1">
                        </a-col>
                        <a-col :span="8">
                            <span class="text-left font-weight">{{ $t('lang.win') }}</span>
                        </a-col>
                    </a-row>
                    <!--                    <div class="ML30">-->
                    <!--                        <img src="../../static/images/u91.png" class="w180" alt="">-->
                    <!--                        <span class="text-left font-weight">{{ $t('lang.innovation') }}</span>-->
                    <!--                    </div>-->
                    <!--                    <div class="ML30">-->
                    <!--                        <img src="../../static/images/u90.png" class="w180" alt="">-->
                    <!--                        <span class="text-left font-weight">{{ $t('lang.Cooperation') }}</span>-->
                    <!--                    </div>-->
                    <!--                    <div class="ML30">-->
                    <!--                        <img src="../../static/images/u92.png" class="w180" alt="">-->
                    <!--                        <span class="text-left font-weight">{{ $t('lang.win') }}</span>-->
                    <!--                    </div>-->
                </a-col>
            </a-row>
        </div>
        <div class="good-div">
            <div style="margin-top: -5px;height: 250px" class="text-align">
                <img src="../../static/images/1593582712.jpg" alt="">
                <p class="font-weight MT-30"><span style="font-size: 30px">{{ $t('lang.Baway') }}</span>
                    <span style="font-size: 42px">{{ $t('lang.advantages') }}</span>
                </p>
            </div>
            <div class="main-div">
                <a-row>
                    <a-col :span="11">
                        <div class="text-align">
                            <img src="../../static/images/u127.png" alt="" class="good-img">
                        </div>
                    </a-col>
                    <a-col :span="2">
                        <div class="margin-auto"
                             style="border: 1px solid #3a8ee6;width: 2px;height: 254px;margin-top: 40px"></div>
                    </a-col>
                    <a-col :span="11">
                        <a-row>
                            <a-col :span="5">
                                <div class="num-div font-weight text-align">
                                    01
                                </div>
                            </a-col>
                            <a-col :span="19">
                                <p style="font-size: 30px" class="font-weight">{{ $t('lang.advantages1') }}</p>
                                <p style="font-size: 18px;margin-top: 15px">
                                    {{ $t('lang.content1') }}
                                </p>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="11">
                        <a-row>
                            <a-col :span="5">
                                <div class="num-div font-weight text-align">
                                    02
                                </div>
                            </a-col>
                            <a-col :span="19">
                                <p style="font-size: 30px" class="font-weight"> {{ $t('lang.advantages2') }}</p>
                                <p style="font-size: 18px;margin-top: 15px">
                                    {{ $t('lang.content2') }}
                                </p>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="2">
                        <div class="margin-auto" style="border: 1px solid #3a8ee6;width: 2px;height: 272px"></div>
                    </a-col>
                    <a-col :span="11">
                        <div class="text-align">
                            <img src="../../static/images/u728.png" alt="" class="good-img">
                        </div>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="11">
                        <div class="text-align">
                            <img src="../../static/images/u729.png" alt="" class="good-img">
                        </div>
                    </a-col>
                    <a-col :span="2">
                        <div class="margin-auto" style="border: 1px solid #3a8ee6;width: 2px;height:321px"></div>
                    </a-col>
                    <a-col :span="11">
                        <a-row>
                            <a-col :span="5">
                                <div class="num-div font-weight text-align">
                                    03
                                </div>
                            </a-col>
                            <a-col :span="19">
                                <p style="font-size: 30px" class="font-weight">{{ $t('lang.advantages3') }}</p>
                                <p style="font-size: 18px;margin-top: 15px">
                                    {{ $t('lang.content3') }}
                                </p>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="11">
                        <a-row>
                            <a-col :span="5">
                                <div class="num-div font-weight text-align">
                                    04
                                </div>
                            </a-col>
                            <a-col :span="19">
                                <p style="font-size: 30px" class="font-weight">{{ $t('lang.advantages4') }}</p>
                                <p style="font-size: 18px;margin-top: 15px">
                                    {{ $t('lang.content4') }}
                                </p>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="2">
                        <div class="margin-auto" style="border: 1px solid #3a8ee6;width: 2px;height: 202px"></div>
                    </a-col>
                    <a-col :span="11">
                        <div class="text-align" style="margin-bottom: 40px">
                            <img src="../../static/images/u780.jpg" alt="" class="good-img">
                        </div>
                    </a-col>
                </a-row>
            </div>
        </div>
        <div class="main-div MT30">
            <div>
                <div class="FR">
                    <a-button type="primary" shape="round" ghost @click="goNews">
                        {{ $t('lang.more') }}
                    </a-button>
                </div>
                <div class="title-max margin-auto">
                    <div class="title-box"></div>
                    <div class="title-box1 text-align">
                        {{ $t('lang.Qualification') }}
                    </div>
                    <div class="MT30 text-align">{{ $t('lang.Professional') }}</div>
                </div>
            </div>
            <a-row class="text-align MT30">
                <a-col :span="6" v-for="(item,i) in news.slice(0 , 4)" :key="i">
                    <img :src="item.image" :alt="item.title" class="cursor-pointer" style="width: 200px;height: 300px"
                         @click="getInfos(item.id)">
                    <p style="font-weight: bold;font-size: 16px;line-height: 40px" class="cursor-pointer"
                       @click="getInfos(item.id)">
                        {{ item.title }}</p>
                    <!--                    <p class="text-left1">{{ item.introduction }}</p>-->
                    <div style="border: 1px solid black;width: 280px;margin:10px 30px"></div>
                    <!--                    <div>-->
                    <!--                        <div class="FL" style="margin-left: 25px;font-size: 20px">{{ item.time }}</div>-->
                    <!--                        <div class="FR" style="margin-right: 30px">-->
                    <!--                            <a-button @click="getInfos(item.id)">查看</a-button>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                </a-col>
            </a-row>
        </div>
        <div class="main-div MT30">
            <div>
                <div class="title-max margin-auto">
                    <div class="title-box"></div>
                    <div class="title-box1 text-align">
                        {{ $t('lang.Popular') }}
                    </div>
                    <div class="MT30 text-align">{{ $t('lang.Professional') }}</div>
                </div>
                <div class="swiper-container border1">
                    <swiper ref="mySwiper" :options="swiperOptions" class="swiper-wrapper" style="margin: 20px 0">
                        <swiper-slide v-for="(item,i) in productData" :key="i" class="swiper-slide cursor-pointer">
                            <div>
                                <div>
                                    <img :src="item.image[0].url" :alt="item.name" style="width: 260px;height: 240px"
                                         @click="getInfo(item.id)">
                                </div>
                                <p><span>{{ item.name }}</span></p>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import carousel from '@/components/carousel.vue'
import navComponent from '@/components/navcomponents.vue'
import {get} from "@/utils";
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'



export default {
    name: 'Home',
    components: {
        carousel,
        navComponent,
        videoPlayer
    },
    data() {
        return {            
            productData: [],
            news: [],            
            swiperOptions: {
                slidesPerView: 5,
                spaceBetween: 30,
                centeredSlides: true,
                loop: true,
                autoplay: true,
            },
            playerOptions: {
            // videojs options
            muted: true,
            language: 'en',
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            fluid: true,
            //aspectRatio: '37:10', 
            sources: [{
                type: "video/mp4",       
               
             // src: window.localStorage.getItem('lang')=='en'?require('../../static/images/en.mp4') :require('../../static/images/chn.mp4')
               src: window.localStorage.getItem('lang')=='en'?'https://www.bawayft.com:7500/baway1English.mp4.mp4' :'https://www.bawayft.com:7500/baway1Chinese.mp4'
                
            }],           
          // poster: require('../../static/images/u66.png'),
           //poster: "http://lbsyun.baidu.com/jsdemo/img/car.png",
            }

        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    mounted() {
        document.title = '贝威科技(潍坊)有限公司-防爆流量计_总氯检测仪_防爆控制器_硬度在线监测仪_TRO检测仪_管道式电磁流量计_船舶水质检测仪_盐度/电导率传感器_船舶压载水简易式余氯'
    },
    created() {
        get('product/getProductCategoryList', {}).then(res => {
            this.navData = res.data.list;
        }).catch(() => {
        })
        get('product/getProductList', {}).then(res => {
            this.productData = res.data.list;
        }).catch(() => {
        })
        get('article/getArticleList', {}).then(res => {
            this.news = res.data.list;
        }).catch(() => {
        })
        // this.productData = (productData.product.filter(item => item.type === 1 || item.type === 2))
        // // this.productData = productData.product;
        // for (let item of this.productData) {
        //     const pic_name = item.src1.slice(20, -4);
        //     item.newSrc1 = require('../../static/images/' + pic_name + '.jpg');
        // }
        // this.news = news.news.slice(0, 3);
        // for (let item of this.news) {
        //     const pic_name = item.src.slice(20, -4);
        //     item.newSrc = require('../../static/images/' + pic_name + '.jpg');
        // }
    },
    methods: {
        getList() {
            this.$router.push({path: '/goods.html'});
        },
        getInfo(id) {
            // this.$router.push({path: '/goodInfo', query: {id}})
            this.$router.push({path: '/goodInfo/' + id + '.html'});
        },
        getInfos(id) {
            // this.$router.push({path: '/newInfo', query: {id}});
            this.$router.push({path: '/qualificationInfo/' + id + '.html'});
        },
        getInfoC() {
            this.$router.push({path: '/introduction.html'});
        },
        goNews() {
            this.$router.push({path: '/qualification.html'});
        }
    },

}
</script>
<style>
/*.swiper-slide-duplicate-prev {*/
/*    margin-left: 30px;*/
/*}*/

/*.swiper-slide-duplicate-active {*/
/*    margin-right: 30px;*/
/*}*/

/*.swiper-slide-duplicate-next {*/
/*    margin-right: 30px;*/
/*}*/
.video-div {
    width: 1120px;  
    
}

.p1 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 7;
    overflow: hidden;
}

.swiper-container {
    width: 100%;
    height: 100%;
}

.border1 {
    border-bottom: 4px solid #4FA0A0;
    border-top: 4px solid #4FA0A0;
    padding: 20px;
    margin-top: 20px;
}

.good-img {
    width: 460px;
    height: 234px;
}

.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: 300ms;
    transform: scale(0.8);
}

.swiper-slide-active, .swiper-slide-duplicate-active {
    transform: scale(1);
}

.num-div {
    width: 100px;
    height: 100px;
    background: #309494;
    border-bottom-right-radius: 50px;
    border-top-left-radius: 50px;
    line-height: 100px;
    font-size: 50px;
    color: white;
}

.good-div {
    width: 100%;
    background: #F2F2F2;
    border-top: 5px solid #F5A100;
    margin-top: 80px;
}

.MT-30 {
    margin-top: -200px;
}

.text-left {
    font-size: 30px;
    margin-left: 10px;
    writing-mode: tb-rl;
}

.w180 {
    width: 180px;
}

.ML30 {
    margin-left: 30px
}
.imgBox {
    width: 450px;
    height: 500px;
}

.imgBox1 {
    border: 4px solid #0099FF;
    position: absolute;
}

.imgBox2 {
    background: #0099FF;
    margin-top: 40px;
    margin-left: 60px;
    position: absolute;
}

.imgBox3 {
    position: absolute;
    margin-top: 20px;
    margin-left: 30px;
}

.text {
    color: rgb(0, 0, 0);
    font-size: 18px;
    line-height: 32px;
}

.range {
    width: 100%;
    height: 424px;
    background: url("../../static/images/u0.png") no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    padding-top: 80px;
}

.range p {
    margin-top: 20px;
}

.img-title {
    width: 240px;
    height: 50px;
    /*line-height: 45px;*/
    display: table-cell;
    vertical-align: middle;
    font-size: 16px;
    border: 2px solid #1890ff;
    background: white;
    cursor: pointer;
}

.img-title:hover {
    border-radius: 5px;
    color: white !important;
    background: #1890ff !important;
}

.ant-carousel >>> .slick-slide {
    text-align: center;
    height: 50px;
    line-height: 50px;
    background: #364d79;
    overflow: hidden;
}

.top-search {
    height: 50px;
    width: 100%;
    background: #949494;
}

.info-img {
    width: 30px;
    margin-top: 10px;
    margin-left: 40px;
}

.carousel-search {
    width: 500px;
    margin-left: 20px;
    height: 50px;
    line-height: 50px;
}

.search-input {
    margin-top: 10px;
    margin-right: 50px;
}

.title-search {
    color: white;
    line-height: 50px;
    margin-right: 30px;
}

.search-box {
    width: 3px;
    height: 30px;
    background: #3a8ee6;
    margin-right: 15px;
    margin-top: 10px;
}
</style>
